export default [
  {
    path: '/app/production',
    name: 'Production',
    component: () => import('@/views/Admin/Production/Index.vue'),
    meta: {
      pageTitle: 'Üretim',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTION_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/production/add',
    name: 'ProductionAdd',
    component: () => import('@/views/Admin/Production/Add.vue'),
    meta: {
      pageTitle: 'Üretim',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/production',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTION_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/production/edit/:id',
    name: 'ProductionEdit',
    component: () => import('@/views/Admin/Production/Edit.vue'),
    meta: {
      pageTitle: 'Üretim',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/production',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTION_EDIT',
      action: 'read',
    },
  },
]
